/**
 * @generated SignedSource<<6fa5378ea8f831f16ca626e032a29c25>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_jiraViewResult$data = {
  readonly __typename: string;
  readonly viewSettings?: {
    readonly hideDone: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"GroupByDropdown" | "SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle">;
  readonly " $fragmentType": "topBar_issueNavigator_jiraViewResult";
};
export type topBar_issueNavigator_jiraViewResult$key = {
  readonly " $data"?: topBar_issueNavigator_jiraViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_jiraViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_jiraViewResult",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
          "kind": "FragmentSpread",
          "name": "GroupByDropdown"
        },
        {
          "kind": "FragmentSpread",
          "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "settings",
              "variableName": "settings"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hideDone"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SaveResetViewSettingsButton"
            }
          ]
        }
      ],
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "d02aa25581520c55aa425caa01b7ec56";

export default node;
